import { React, useState, useRef } from "react";
const MarketAnalysisFootballFancy = ({ footballFancy, footballFancyBook }) => {
  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const getBookValue = (cat_mid, num) => {
    if (!footballFancyBook || !footballFancyBook.length) return null;
    const row = footballFancyBook.find(
      (item) => String(item.cat_mid) === String(cat_mid)
    );
    if (!row) return null;
    const raw = num === 1 ? row.rnr1s : row.rnr2s;
    if (raw === undefined || raw === null || raw === "") return null;
    return Math.round(Number(raw) * -1);
  };

  const renderBook = (cat_mid, num) => {
    const bookValue = getBookValue(cat_mid, num);
    return (
      <span className="position-plus site_family">
        <strong
          style={{
            color: (bookValue || 0) >= 0 ? "green" : "red",
            display: bookValue === null ? "none" : ""
          }}
        >
          {bookValue === null ? "" : formatTruncate(bookValue)}
        </strong>
      </span>
    );
  };

  return (
    <div style={{ marginTop: "10px" }}>
      <style>
        {`


.table-box-body {
  background-color: transparent; 
}
.bg-gray, .Bl_NT_DB_LITE, .table-box-body, tabcontent {
   background-color: transparent;
}
        `}
      </style>
      <div className="table-box-body">
        <div className="card card-accent-success">
          <div style={{ marginBottom: "0px" }}>
            <div className="row bg-gray-100 market-head">
              <div className="col-12">
                <strong className="site_family">Fancy</strong>
              </div>
            </div>
          </div>
          <div class="tb-content">
            {footballFancy !== null &&
              footballFancy !== undefined &&
              footballFancy !== "" &&
              footballFancy.map((fancy) => (
                <div>
                  <div class="row bg-gray-100 market-head">
                    <div class="col-12">
                      <strong className="site_family">{fancy.name}</strong>
                      &nbsp;{" "}
                      <a
                        className="cursor-pointer"
                        onClick={() => {
                          const width = 1200;
                          const height = 560;
                          const left =
                            window.screenX + (window.outerWidth - width) / 2;
                          const top =
                            window.screenY + (window.outerHeight - height) / 2;

                          window.open(
                            `/agent/user-book/${fancy.cat_mid}/6`,
                            "UserBookWindow",
                            `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
                          );
                        }}
                      >
                        <i class="fa fa-address-book"></i>
                      </a>
                    </div>
                  </div>

                  <div class="row runners">
                    <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                      <strong
                        style={{ fontSize: "1rem" }}
                        className="site_family"
                      >
                        {fancy.runner1}
                      </strong>{" "}
                      <br /> <span>{renderBook(fancy.cat_mid, 1)}</span>{" "}
                    </div>{" "}
                    <div class="col-5 col-md-8 price">
                      <div class="row">
                        <div class="col-md-2 d-none d-md-block cta-back">
                          <div id="b3-54600" class="col-12 price site_family">
                            {fancy?.odd?.r1b3}
                          </div>{" "}
                          <div id="bs3-54600" class="col-12 size site_family">
                            {fancy?.odd?.rate3}
                          </div>
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-back">
                          <div
                            id="b2-54600"
                            class="col-md-12 col-sm-12 price site_family"
                          >
                            {fancy?.odd?.r1b2}
                          </div>{" "}
                          <div
                            id="bs2-54600"
                            class="col-md-12 col-sm-12 size site_family"
                          >
                            {fancy?.odd?.rate2}
                          </div>
                        </div>{" "}
                        <div class="col-6 col-md-2 cta-back">
                          <div
                            id="b1-54600"
                            class="col-12 price site_family"
                            style={{ backgroundColor: "rgb(227, 248, 255)" }}
                          >
                            {fancy?.odd?.r1b}
                          </div>{" "}
                          <div
                            id="bs1-54600"
                            class="col-12 size site_family"
                            style={{ backgroundColor: "rgb(227, 248, 255)" }}
                          >
                            {fancy?.odd?.rate1}
                          </div>
                        </div>{" "}
                        <div class="col-6 col-md-2 cta-lay">
                          <div
                            id="l1-54600"
                            class="col-md-12 col-sm-12 price site_family"
                            style={{ backgroundColor: "rgb(255, 205, 204)" }}
                          >
                            {fancy?.odd?.r1l}
                          </div>{" "}
                          <div
                            id="ls1-54600"
                            class="col-md-12 col-sm-12 size site_family"
                            style={{ backgroundColor: "rgb(255, 205, 204)" }}
                          >
                            {fancy?.odd?.rate4}
                          </div>
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-lay">
                          <div
                            id="l2-54600"
                            class="col-md-12 col-sm-12 price site_family"
                          >
                            {fancy?.odd?.r1l2}
                          </div>{" "}
                          <div
                            id="ls2-54600"
                            class="col-md-12 col-sm-12 size site_family"
                          >
                            {fancy?.odd?.rate5}
                          </div>
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-lay">
                          <div
                            id="l3-54600"
                            class="col-md-12 col-sm-12 price site_family"
                          >
                            {fancy?.odd?.r1l3}
                          </div>{" "}
                          <div
                            id="ls3-54600"
                            class="col-md-12 col-sm-12 size site_family"
                          >
                            {fancy?.odd?.rate6}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row runners lastItemBorder">
                    <div class="col-7 col-md-4" style={{ paddingTop: "3px" }}>
                      <strong
                        style={{ fontSize: "1rem" }}
                        className="site_family"
                      >
                        {fancy.runner2}
                      </strong>{" "}
                      <br /> <span>{renderBook(fancy.cat_mid, 2)}</span>{" "}
                    </div>{" "}
                    <div class="col-5 col-md-8 price">
                      <div class="row">
                        <div class="col-md-2 d-none d-md-block cta-back">
                          <div id="b3-54600" class="col-12 price site_family">
                            {fancy?.odd?.r2b3}
                          </div>{" "}
                          <div id="bs3-54600" class="col-12 size site_family">
                            {fancy?.odd?.rate9}
                          </div>
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-back">
                          <div
                            id="b2-54600"
                            class="col-md-12 col-sm-12 price site_family"
                          >
                            {fancy?.odd?.r2b2}
                          </div>{" "}
                          <div
                            id="bs2-54600"
                            class="col-md-12 col-sm-12 size site_family"
                          >
                            {fancy?.odd?.rate8}
                          </div>
                        </div>{" "}
                        <div class="col-6 col-md-2 cta-back">
                          <div
                            id="b1-54600"
                            class="col-12 price site_family"
                            style={{ backgroundColor: "rgb(227, 248, 255)" }}
                          >
                            {fancy?.odd?.r2b}
                          </div>{" "}
                          <div
                            id="bs1-54600"
                            class="col-12 size site_family"
                            style={{ backgroundColor: "rgb(227, 248, 255)" }}
                          >
                            {fancy?.odd?.rate7}
                          </div>
                        </div>{" "}
                        <div class="col-6 col-md-2 cta-lay">
                          <div
                            id="l1-54600"
                            class="col-md-12 col-sm-12 price site_family"
                            style={{ backgroundColor: "rgb(255, 205, 204)" }}
                          >
                            {fancy?.odd?.r2l}
                          </div>{" "}
                          <div
                            id="ls1-54600"
                            class="col-md-12 col-sm-12 size site_family"
                            style={{ backgroundColor: "rgb(255, 205, 204)" }}
                          >
                            {fancy?.odd?.rate10}
                          </div>
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-lay">
                          <div
                            id="l2-54600"
                            class="col-md-12 col-sm-12 price site_family"
                          >
                            {fancy?.odd?.r2l2}
                          </div>{" "}
                          <div
                            id="ls2-54600"
                            class="col-md-12 col-sm-12 size site_family"
                          >
                            {fancy?.odd?.rate11}
                          </div>
                        </div>{" "}
                        <div class="col-md-2 d-none d-md-block cta-lay">
                          <div
                            id="l3-54600"
                            class="col-md-12 col-sm-12 price site_family"
                          >
                            {fancy?.odd?.r2l3}
                          </div>{" "}
                          <div
                            id="ls3-54600"
                            class="col-md-12 col-sm-12 size site_family"
                          >
                            {fancy?.odd?.rate12}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketAnalysisFootballFancy;